import { Icon } from '@driftt/tide-core-legacy'
import { getEloquaConfig, patchEloquaConfig } from 'app/modules/integrations/api'
import AutoSyncCallout from 'components/Integration/components/AutoSyncCallout'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import IntegrationToggles from 'components/IntegrationToggles'
import withNotifications from 'components/shared/notifications'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import * as OrgSelectors from 'app/modules/org/selectors'
import { connect } from 'react-redux'
import { hydrateModel, model } from './model'

const CONNECT_ERROR_MESSAGE = 'We could not fetch your settings.'
const PATCH_ERROR_MESSAGE = 'We could not save your changes.'

class EloquaConfig extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    eloquaSyncContactsEnabled: model[0],
    eloquaShouldSetLeadOwner: model[1],
    eloquaShouldOnlySyncQualifiedContacts: model[2],
    eloquaSyncConversationTranscriptsEnabled: model[3],
    cookieIdentificationEnabled: model[4]
  }

  componentDidMount() {
    getEloquaConfig()
      .then(this.receiveToggles)
      .catch(this.onError)
  }

  onError = () => {
    const { router } = this.context

    this.props.notifications.error(CONNECT_ERROR_MESSAGE)
    router.push({ pathname: `/settings/setup/eloqua` })
  }

  onPatchError = () => {
    this.props.notifications.error(PATCH_ERROR_MESSAGE)
  }

  receiveToggles = resp => {
    this.setState({
      eloquaSyncContactsEnabled: hydrateModel(resp)[0],
      eloquaShouldSetLeadOwner: hydrateModel(resp)[1],
      eloquaShouldOnlySyncQualifiedContacts: hydrateModel(resp)[2],
      eloquaSyncConversationTranscriptsEnabled: hydrateModel(resp)[3],
      cookieIdentificationEnabled: hydrateModel(resp)[4]
    })
  }

  settingsUpdatedNotification = () => this.props.notifications.success('Eloqua settings are updated!')

  patchToggle = (event, toggle) => {
    const data = { [toggle.type]: event }

    patchEloquaConfig(data)
      .then(this.receiveToggles)
      .then(this.settingsUpdatedNotification)
      .catch(this.onPatchError)
  }


  render() {
    const { eloquaSyncContactsEnabled, eloquaShouldSetLeadOwner, eloquaShouldOnlySyncQualifiedContacts, eloquaSyncConversationTranscriptsEnabled, cookieIdentificationEnabled } = this.state
    const hasEloquaCDO = this.props.userGates.get("eloqua_mapped_cdos") || false
    return (
      <div className="common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Eloqua Integration"
          backLinkUrl={`/settings/setup/eloqua`}
        />
        <header>
          <h2 className="integration-header">Synced Eloqua Data</h2>
          <p>Choose which data is sent between Eloqua and Drift.</p>
        </header>

        <h3 className="integration-header">
          Drift
          <Icon
            className="right-arrow"
            width={15}
            height={10}
            name="arrow-2-right"
          />
          Eloqua
        </h3>
        <AutoSyncCallout integrationName="Eloqua" />
        <IntegrationToggles
          toggles={true ? [eloquaShouldOnlySyncQualifiedContacts] : []}
          onChange={this.patchToggle}
        />
        <IntegrationToggles
          toggles={[eloquaSyncContactsEnabled]}
          onChange={this.patchToggle}
        />
        <IntegrationToggles
          toggles={[eloquaSyncConversationTranscriptsEnabled]}
          onChange={this.patchToggle}
          disabled={!hasEloquaCDO}
          isToggleAvailableForOrg={hasEloquaCDO}
        />
        <h3 className="integration-header">
          Eloqua
          <Icon
            className="right-arrow"
            width={15}
            height={10}
            name="arrow-2-right"
          />
          Drift
        </h3>
        <IntegrationToggles
          toggles={[cookieIdentificationEnabled]}
          onChange={this.patchToggle}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userGates: OrgSelectors.userGates(state)
})

export default connect(mapStateToProps)(
  withNotifications(EloquaConfig)
)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/EloquaConfig/index.js